import React, { useEffect } from 'react';
import './index.less';

const PageTech = props => {
    const { anchor, BubbleMachine, current } = props;
    const graphVW = anchor.isMobile ? 1.52 : 1.2635;
    let ele = document.getElementById('enterUniver');
    useEffect(() => {
        if (ele) {
            ele.addEventListener('mouseover', enter);
            ele.addEventListener('mouseout', out);
        }
    }, [ele])
    const enter = () => {
        ele.style.cssText = 'transform:scale(1.05) !important;transition:all 0.4s linear;';
    }
    const out = () => {
        ele.style.cssText = 'transform:scale(1) !important;transition:all 0.4s linear;';
    }

    return (
        <div className='pagetech'>
            <div className="ai_content">
                <div className="ai_left">
                    <div className="ai_left_img">
                        <div>
                            <img src='/assets/ai.png' style={{ width: `${anchor.scale * 92}px`, minWidth: 50 }} />
                        </div>
                        <div style={{ marginTop: `${anchor.isMobile ? 14 : 20}px` }}>
                            <img src='/assets/expert.png' style={{ width: `${anchor.scale * 348}px`, minWidth: 150 }} />
                        </div>
                        <div className="right_btn">
                            <a href='http://university.zhipu.ai' id='enterUniver' target="_block">
                                点击进入
                            </a>
                        </div>
                    </div>
                </div>
                <div className="ai_right">
                    <div className="ai_right_img">
                        <img src='/assets/ai_img.png' style={{ width: `${anchor.scale * 900}px`, minWidth: 300 }} />
                        {
                            current == 2 && <BubbleMachine anchor={anchor} vw={graphVW} bgColor='#e7f3fe' />
                        }
                    </div>
                    {
                        !!anchor.isMobile
                        &&
                        <img
                            src='/assets/top_text_6.png'
                            className='top_text_6'
                            style={{ width: `${anchor.scale * 26}px`, marginTop: 140, minWidth: 16 }}
                        />
                    }
                </div>

            </div>
        </div>
    )
}

export default PageTech;